export default "__VITE_ASSET__BJvTfS5e__"